"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RoomTypePriceSetting;
(function (RoomTypePriceSetting) {
    RoomTypePriceSetting[RoomTypePriceSetting["room"] = 0] = "room";
    RoomTypePriceSetting[RoomTypePriceSetting["bed"] = 1] = "bed";
    RoomTypePriceSetting[RoomTypePriceSetting["unit"] = 2] = "unit";
})(RoomTypePriceSetting = exports.RoomTypePriceSetting || (exports.RoomTypePriceSetting = {}));
